"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PreviousCta = void 0;
var _FormattedMessage = require("../FormattedMessage");
var _Cta = require("./Cta");
var _jsxRuntime = require("react/jsx-runtime");
const PreviousCta = props => /*#__PURE__*/(0, _jsxRuntime.jsx)(_Cta.Cta, {
  variant: "outlined",
  color: "primary",
  ...props,
  children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_FormattedMessage.FormattedMessage, {
    id: "previous"
  })
});
exports.PreviousCta = PreviousCta;
